<div class="container px-4 py-5" id="featured-3">
  <div class="row g-4 py-5 row-cols-1 row-cols-lg-2">
    <div class="feature col">
      <div class="feature-icon d-inline-flex align-items-center justify-content-center  bg-gradient fs-2 mb-3">
<!--        <svg class="bi" width="1em" height="1em"><use xlink:href="#collection"/></svg>-->
        <img ngSrc="/assets/img/aboutUs/mision.svg" class="" width="50" height="50" alt="">
      </div>
      <h3 class="fs-3 fw-bold" style="color: var(--primary-color)">Misión</h3>
      <p class="fs-5 text-secondary">Brindar servicios de salud priorizando el bienestar de cada persona. En Medilink, nuestro compromiso es inspirar a las personas a cuidar de su salud.</p>

    </div>
    <div class="feature col">
      <div class="feature-icon d-inline-flex align-items-center justify-content-center  bg-gradient fs-2 mb-3">
        <img ngSrc="/assets/img/aboutUs/vision.svg" class="" width="50" height="50" alt="">
      </div>
      <h3 class="fs-3 fw-bold" style="color: var(--primary-color)">Visión</h3>
      <p class="fs-5 text-secondary">Ser la red de estaciones de salud más confiable y cercana del Ecuador, donde cada usuario se sienta valorado en su búsqueda del bienestar. En Medilink, aspiramos a transformar los servicios de salud en una experiencia de amor y cuidado.</p>

    </div>

  </div>
</div>
